(function () {
  let initialized = false;
  let currentInput = null;
  let currentButton = null;

  function initCouponScript() {
    if (!window.CouponCodeManager) return;

    const input = document.getElementById('cart-cupom');
    const button = document.getElementById('cart-apply-coupon');
    const label = document.querySelector('label[for="cart-cupom"]');

    if (!input || !button) {
      return;
    }

    if (initialized && currentInput === input && input.isConnected) {
      return;
    }

    initialized = true;
    currentInput = input;
    currentButton = button;

    function updateCouponLabelVisibility() {
      const hasCoupon = document.querySelector('.coupon-pill') !== null;
      if (label) {
        if (hasCoupon) {
          label.classList.add('is-hidden');
        } else {
          label.classList.remove('is-hidden');
        }
      }
    }

    function showCouponError(message = 'Cupom inválido ou indisponível') {
      input.classList.add('error');
      let errorMsg = document.getElementById('coupon-error-message');
      if (!errorMsg) {
        errorMsg = document.createElement('div');
        errorMsg.id = 'coupon-error-message';
        errorMsg.className = 'coupon-error-message';
        input.parentNode.insertAdjacentElement('afterend', errorMsg);
      }
      errorMsg.textContent = message;
      errorMsg.style.display = 'block';
    }

    function clearCouponError() {
      input.classList.remove('error');
      const errorMsg = document.getElementById('coupon-error-message');
      if (errorMsg) {
        errorMsg.style.display = 'none';
      }
    }

    function setLoading(isLoading) {
      input.disabled = isLoading;
      button.disabled = isLoading;

      if (isLoading) {
        const spinner = document.createElement('span');
        spinner.className = 'spinner';
        spinner.id = 'coupon-spinner';
        button.textContent = '';
        button.appendChild(spinner);
      } else {
        const spinner = button.querySelector('#coupon-spinner');
        if (spinner) spinner.remove();
        button.textContent = 'Aplicar';
      }
    }

    function applyCoupon() {
      const code = input.value.trim();

      if (!code) {
        return;
      }

      clearCouponError();
      setLoading(true);

      window.CouponCodeManager.applyDiscount(code)
        .then((cartAfter) => {
          const isApplicable = window.CouponCodeManager.isCouponApplicable(cartAfter, code);

          if (isApplicable) {
            input.value = '';
            clearCouponError();

            setTimeout(() => {
              updateCouponLabelVisibility();
            }, 100);

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'main-cart-coupon', cartData: cartAfter });
            }
          } else {
            showCouponError('Cupom inválido ou indisponível');
          }
        })
        .catch((err) => {
          console.error('[Main Cart Coupon] Erro ao aplicar cupom:', err);
          showCouponError('Cupom inválido ou indisponível');
        })
        .finally(() => {
          setLoading(false);
        });
    }

    function removeCoupon(couponCode) {
      setLoading(true);

      window.CouponCodeManager.removeDiscount()
        .then((cart) => {
          
          setTimeout(() => {
            updateCouponLabelVisibility();
          }, 100);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'main-cart-coupon', cartData: cart });
          }
        })
        .catch((err) => {
          console.error('[Main Cart Coupon] Erro ao remover cupom:', err);
        })
        .finally(() => {
          setLoading(false);
        });
    }

    if (!button.dataset.couponBound) {
      button.addEventListener('click', applyCoupon);
      button.dataset.couponBound = 'true';
    }

    if (!input.dataset.couponBound) {
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          applyCoupon();
        }
      });

      input.addEventListener('input', () => {
        clearCouponError();
      });

      input.dataset.couponBound = 'true';
    }

    const couponContainer = input.closest('.cart-section__content') || document;
    const removeButtons = couponContainer.querySelectorAll('.coupon-pill__remove');
    removeButtons.forEach((btn) => {
      if (btn.dataset.couponBound) {
        return;
      }
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        const couponCode = btn.closest('[data-coupon-code]').getAttribute('data-coupon-code');
        removeCoupon(couponCode);
      });
      btn.dataset.couponBound = 'true';
    });

    updateCouponLabelVisibility();

    if (!window.__MAIN_CART_COUPON_EVENTS_BOUND) {
      window.__MAIN_CART_COUPON_EVENTS_BOUND = true;

      document.addEventListener('cart:dom-updated', function () {
        initCouponScript();
      });
    }
  }

  if (!window.__MAIN_CART_COUPON_OBSERVED) {
    window.__MAIN_CART_COUPON_OBSERVED = true;

    const observer = new MutationObserver(() => {
      initCouponScript();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCouponScript);
  } else {
    initCouponScript();
  }
})();
